'use strict';
require('user/UserService.js');

function UserActivateAliasCtrl(
  UserService,
  $state,
  $stateParams) {
  UserService.getActivateAlias({code: decodeURIComponent($stateParams.code), email: decodeURIComponent($stateParams.email)}).$promise.then(function() {
    $state.go("login", {}, { inherit: false });
  }, function() {
    $state.go("404");
  });
}

angular.module('dokiv')
  .controller('UserActivateAliasCtrl', [
    'UserService',
    '$state',
    '$stateParams', UserActivateAliasCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/user/UserActivateAliasCtrl.js
// module id = 435
// module chunks = 0